import Link from "next/link"
import useOnclickOutside from "react-cool-onclickoutside"
import { Photo } from "../../../components/media/Photo"

export const VenuesMapMarker = ({
  venue,
  onMouseOver,
  onMouseLeave,
  onSelectVenue,
  hoovered = false,
  selected = false,
  lat,
  lng,
}) => {
  const ref = useOnclickOutside(() => {
    onSelectVenue(undefined)
  })
  return (
    <div className="relative">
      <div
        onMouseEnter={onMouseOver ? () => onMouseOver(venue) : undefined}
        onMouseLeave={onMouseLeave ? () => onMouseLeave(venue) : undefined}
        onClick={() => onSelectVenue(venue)}
        className="font-bold flex items-center justify-center cursor-pointer w-11 h-11"
        // className="bg-themeOrange"
        style={{
          transform: hoovered ? "scale(1.1)" : null,
          // background: "var(--moje-color-magenta)",
          color: "var(--moje-color-black-blue)",
          padding: "10px 12px",
          borderRadius: "20px",
        }}
      >
        <img
          src={
            venue.category?.type === "SERVICES"
              ? "/assets/venues/map_marker_service.svg"
              : "/assets/venues/map_marker_place.svg"
          }
          alt="Map Marker"
        />
      </div>
      {selected && (
        <Link href={`/miejsce/${venue?.slug ?? venue?.id}`} passHref>
          <a href={`/miejsce/${venue?.slug ?? venue?.id}`}>
            <div
              ref={ref}
              className="z-10 absolute overflow-hidden top-14"
              style={{
                boxShadow: "0 0 20px rgba(150, 150, 150, 1)",
                borderRadius: "15px",
                width: "240px",
                left: "calc(-120px + 22px)",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  height: "120px",
                  background: "#f0f0f0",
                }}
              >
                {venue.media && venue.media.length > 0 ? (
                  <Photo media={venue.media[0]} radius={false} />
                ) : (
                  <span />
                )}
              </div>
              <div
                className="bg-white p-3 flex flex-col"
                style={{ height: "120px" }}
              >
                <div className="font-bold text-base leading-5 mb-1 ">
                  {venue.name}
                </div>
                <div>
                  {venue.city && (
                    <div
                      className="text-sm sm:text-sm text-gray-600 font-light"
                      title={venue.distance}
                    >
                      {venue.city} {venue.address}
                    </div>
                  )}
                </div>
                <div className="text-black font-normal text-xs flex-auto">
                  {venue.minPrice && (
                    <>
                      <strong>{venue.minPrice} zł</strong>
                    </>
                  )}
                </div>
                <div className="my-1"></div>
              </div>
            </div>
          </a>
        </Link>
      )}
    </div>
  )
}
